import {AttributeStatusColorEnum} from '../model/AttributeModel'
import {IconDisplay} from '../../genericComponents/IconDisplay'


export const RegulationStatusColorAttribute = ({ statusColor }: { statusColor: string | undefined }) => {

    const statusColorIconSourceMap = new Map<AttributeStatusColorEnum | string, {url: string, label: string}>([
        [AttributeStatusColorEnum.GREEN, {url: '/images/custom-icons/StatusCompliant.svg', label: AttributeStatusColorEnum.GREEN}],
        [AttributeStatusColorEnum.ORANGE, {url: '/images/custom-icons/StatusCompliantException.svg', label: AttributeStatusColorEnum.ORANGE}],
        [AttributeStatusColorEnum.GREY, {url: '/images/custom-icons/StatusUnknown.svg', label: AttributeStatusColorEnum.GREY}],
        [AttributeStatusColorEnum.RED, {url: '/images/custom-icons/StatusNonCompliant.svg', label: AttributeStatusColorEnum.RED}],
    ])

    if (!statusColor) return <></>
    return <IconDisplay data-testid="test-details-attribute-status-color-icon" className="attribute-status-color-icon"
                        iconName={statusColor} iconSourceMap={statusColorIconSourceMap} iconLabel={statusColor} />
}